import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import dashboardService from '../../services/dashboardService';
import styles from './PendingAmountList.module.scss';
import { formatCurrency } from '../../utils/helpers';

interface PendingAmountRow {
  id: string; // customer_id from backend
  customer_name: string;
  phone_number: string;
  total_amount: number;
  balance: number;
}

const ExtraAmountList: React.FC = () => {
  const navigate = useNavigate();
  const [pendingList, setPendingList] = useState<PendingAmountRow[]>([]);
  const [search, setSearch] = useState('');
  const [filtered, setFiltered] = useState<PendingAmountRow[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const data = await dashboardService.getExtraAmountList();
        setPendingList(data);
        setFiltered(data);
      } catch (err) {
        setPendingList([]);
        setFiltered([]);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (!search) {
      setFiltered(pendingList);
    } else {
      const s = search.toLowerCase();
      setFiltered(
        pendingList.filter(row =>
          row.customer_name.toLowerCase().includes(s) ||
          row.phone_number.toLowerCase().includes(s)
        )
      );
    }
  }, [search, pendingList]);

  const handleViewCustomer = (customerId: string) => {
    navigate(`/customers/${customerId}`);
  };

  return (
    <div className={styles.pendingAmountPage}>
      <h2 className={styles.title}>Extra Amount</h2>
      <div className={styles.searchBar}>
        <input
          type="text"
          placeholder="Search by customer name or phone number..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          className={styles.searchInput}
        />
      </div>
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Customer Name</th>
              <th>Phone Number</th>
              <th>Total Amount</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={4} className={`${styles.centerMessage} centerMessage`}>Loading...</td></tr>
            ) : filtered.length === 0 ? (
              <tr><td colSpan={4} className={`${styles.centerMessage} centerMessage`}>No data found.</td></tr>
            ) : (
              filtered.map((row, idx) => (
                <tr key={idx}>
                  <td>{row.customer_name}</td>
                  <td>{row.phone_number}</td>
                  <td>{formatCurrency(row.balance)}</td>
                  <td>
                    <button
                      onClick={() => handleViewCustomer(row.id)}
                      className={styles.actionButton}
                      title="View Customer Details"
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                        <circle cx="12" cy="12" r="3"></circle>
                      </svg>
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ExtraAmountList; 